import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';
import useQueryFilter from 'hooks/useQueryFilter';
import useQueryParams from 'hooks/useQueryParams';
import { useTranslation } from 'react-i18next';

import './ClearFilters.styles.scss';

type ClearFiltersProps = {
  className?: string;
  filters?: string[];
  text?: string;
  customOnClick?: () => void;
};

const ClearFilters: React.FC<ClearFiltersProps> = (props) => {
  const { className, filters, text, customOnClick } = props;

  const classes = classNames(
    'clear-filters',
    'as-link',
    'clear-all',
    className,
  );

  const { t } = useTranslation();

  const { params, hasActiveFilter, resetFilters } = useQueryFilter();
  const { removeAllQueryParams } = useQueryParams();

  const hasClearButton = useMemo(
    () =>
      filters?.length
        ? Object.keys(params).some((el) => filters.includes(el))
        : hasActiveFilter,
    [filters, hasActiveFilter, params],
  );

  const handleOnClear = useCallback(() => {
    if (filters?.length) {
      resetFilters(filters);
    } else removeAllQueryParams();

    customOnClick?.();
  }, [filters, removeAllQueryParams, resetFilters, customOnClick]);

  if (!hasClearButton) return null;

  return (
    <Button
      className={classes}
      type="button"
      icon={XIcon}
      onClick={handleOnClear}
    >
      {text || t('clearFilters')}
    </Button>
  );
};

export default ClearFilters;
